export enum AuthRedirectType {
    /**
     * Redirects user to the checkout page after login.
     */
    Checkout = 'checkout',

    /**
     * With this option, no redirect will be performed after login.
     * This option can be useful when the component that triggers the login
     * wants to have full control over the redirect.
     */
    Disabled = 'disabled',

    /**
     * With this option, the redirect will take the user to any path provided
     * by the component calling the login hook.
     * This option can be used in situations where a very specific redirect
     * is needed
     */
    Path = 'path',

    /**
     * This is the default redirect after a succeful login. The user is taken
     * to their profile page, using their primary Yat as path.
     */
    Profile = 'profile',
}

export type AuthRedirect = {
    type: AuthRedirectType;
    path?: string;
};

export interface AuthenticateOptions {
    redirect?: AuthRedirect;
}
